import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
const nodeUrl = require('url');
export default {
  computed: {
    ...mapState({
      State: state => state
    })
  },
  created() {
    const URL = nodeUrl.parse(location.href, true);
    const partyCode = URL.query.id || URL.query.join_id;
    const hasLogin = this.State.hasLogin;
    const isIntercomModule = this.$route.name.includes('intercom');
    if (hasLogin) {
      if (!partyCode && this.$route.name != 'globalControl' && !isIntercomModule) {
        this.$router.push({
          name: 'manage'
        });
      }
    } else {
      if (isIntercomModule) return;
      this.$router.push({
        name: 'preview',
        query: {
          id: partyCode
        }
      });
    }
  }
};